/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LegislationsOptions } from 'services/legislations';
import { ApplicationState } from 'store';
import { JuridicoFacilState, JuridicoFacilTypes } from 'store/modules/juridico_facil_store/types';

interface SearchJuridicoProps {
  params: any;
}

const SearchJuridico = (props: SearchJuridicoProps) => {
  const { params } = props;
  const [type, setType] = useState<number>();
  const [search, setSearch] = useState<string>(params?.search || '');
  const dispatch = useDispatch();

  useEffect(() => {
    setType(params?.tipo || 0);
  }, []);

  const foundOption = LegislationsOptions.find(
    (option) => option?.value?.toString() === type?.toString(),
  );

  const { juridico } = useSelector<ApplicationState, JuridicoFacilState>(
    (state) => state.session.juridico,
  );

  const handleClick = () => {
    window.location.href = `/juridico/search/${search}/${type}/${juridico?.accept}/${juridico?.video_show}/0/0`;
  };

  const handleDropdownClick = (value: number, event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setType(value);
  };

  return (
    <div className="card p-2">
      <div className="card-body d-flex flex-column flex-md-row align-items-center">
        <input
          type="text"
          className="form-control mb-2 mb-md-0"
          required
          placeholder="Pesquisar"
          value={search}
          onChange={(e) => {
            const value = e.target.value.replace(/[^a-zA-Z0-9À-ÿ\s]/g, '');
            setSearch(value);
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleClick();
          }}
        />
        <div className="dropdown mb-2 mb-md-0 mr-2">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {foundOption?.label}
          </button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            {LegislationsOptions.map(({ value, label }) => (
              <a
                key={value}
                className="dropdown-item"
                href="#"
                onClick={(e) => handleDropdownClick(value, e)}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
        <button type="button" className="btn btn-primary" disabled={!search} onClick={handleClick}>
          Pesquisar
        </button>
      </div>
      <div className="px-4">
        <label className="mr-3 mb-0 d-inline-flex align-items-center">
          <input
            type="checkbox"
            className="mr-2"
            checked={juridico?.accept}
            onClick={() =>
              dispatch({
                type: JuridicoFacilTypes.ACCEPT,
                accept: !juridico?.accept,
              })
            }
          />
          Busca exata
        </label>
        <label className="mb-0 d-inline-flex align-items-center">
          <input
            type="checkbox"
            className="mx-2"
            checked={juridico?.video_show}
            onClick={() =>
              dispatch({
                type: JuridicoFacilTypes.VIDEO,
                video_ativo: !juridico?.video_show,
              })
            }
          />
          Dica com vídeo
        </label>
      </div>
    </div>
  );
};

export default SearchJuridico;
